PLAYER p1 20 You
PLAYER p2 20 Practice partner
ACTIVE p1
p1 battlefield Mountain | copies=2
p1 hand Lightning Bolt
p1 hand Shock
p1 library Forest | copies=20
p2 library Forest | copies=20
